import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import './assets/fonts/fonts.css';

let theme = createTheme();

theme = createTheme({
  components: {
    // Replace `overrides` with `components`
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: 'smooth', // Enable smooth scrolling for in-page navigation
        },
        h1: {
          fontWeight: 500,
        },
        h2: {
          fontWeight: 500,
        },
        h3: {
          fontWeight: 500,
        },
        h4: {
          fontWeight: 500,
        },
        h5: {
          fontWeight: 500,
        },
        h6: {
          fontWeight: 500,
        },
        h7: {
          fontWeight: 500,
        },
        strong: {
          fontWeight: 500,
        },
        b: {
          fontWeight: 500,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          fontSize: 14,
          lineHeight: 16 / 14,
          width: 206,
          padding: '12px 24px',
          color: '#4849d3',
          textTransform: 'none',
        },
        outlined: {
          textTransform: 'none',
        },
      },
    },
  },
  typography: {
    fontFamily: 'NeueHaasGroteskDisp WO2',
    body1: {
      color: '#101820',
      letterSpacing: '-0.02em',
      fontWeight: 400,
    },
    body2: {
      color: '#101820',
      letterSpacing: '-0.02em',
      fontWeight: 400,
    },
    body3: {
      color: '#101820',
      letterSpacing: '-0.02em',
      fontWeight: 400,
      fontSize: '12px',
    },
    h1: {
      color: '#101820',
      letterSpacing: '-0.02em',
      fontWeight: 500,
    },
    h2: {
      color: '#101820',
      letterSpacing: '-0.02em',
      fontWeight: 500,
      lineHeight: 1,
    },
    h3: {
      color: '#101820',
      letterSpacing: '-0.02em',
      fontWeight: 500,
    },
    h4: {
      color: '#101820',
      letterSpacing: '-1px',
      fontWeight: 500,
    },
    h5: {
      color: '#101820',
      fontWeight: 500,
    },
    h6: {
      color: '#101820',
      fontWeight: 500,
      fontSize: '18px',
    },
    overline: {
      color: '#101820',
      fontWeight: 500,
      letterSpacing: '-0.02em',
    },
    subtitle1Med: {
      letterSpacing: '-0.02em',
      fontWeight: 500,
    },
    subtitle1: {
      color: '#101820',
      letterSpacing: '-0.02em',
      fontWeight: 400,
    },
  },
  palette: {
    black: {
      darkSeaBlack: '#101820',
      coolGrey: '#565E63',
      stoneSilver: '#BCC9C5',
      paleSilver: '#EAF1EF',
      paragraphText: '#393E45',
    },
    googleText: { text: '#4285F4', border: '#3FA7F3' },
    primary: {
      main: '#BBF45D',
      pistachio: '#D3FF8D',
      palePistachio: '#E3FFB6',
      extraPalePistachio: '#e3ffb62b',
    },
    secondary: {
      main: '#6D53EB',
      lightPurple: '#8070ED',
      lavender: '#9B91FF',
      lightLavender: '#B3AFFF',
      paleLavender: '#CCC9FF',
    },
    adminBlue: {
      main: '#0017FF',
      paleBlue: '#E0E3FF',
      veryPaleBlue: '#F5F6FF',
      lightBlue: '#ECF2FB',
      veryLightBlue: '#F8F8FF',
    },
    grey: {
      white: '#FFFFFF',
      deepWarmGrey: '#606060',
      warmGrey: '#8E8E8E',
      lightGrey: '#F5F5F5',
      lightWarmGrey: '#D3D3D3',
      dividersColor: '#CCCCCC',
    },
    status: {
      disabledDark: '#ACACAC',
      disabledLight: '#D9D9D9',
      errorDark: '#E16969',
      errorLight: '#F6DADA',
      warningDark: '#F4B85D',
      warningLight: '#F7C393',
      successDark: '#00C489',
      successLight: '#ECF2F1',
      download: '#B3AFFF',
    },
    chart: {
      unConfirmed: '#0f1720',
      cancelled: '#b3afff',
      active: '#f4b85d',
      completed: '#d3ff8d',
      notFeasible: '#e47d7d',
      confirmed: '#78909C',
      centerText: '#2A5CAA',
    },
  },
  spacing: 10,
  shape: {
    borderRadius: 0,
  },
  pageSection: {
    padding: '8rem',
  },
  custom: {
    drawerWidth: 340,
  },
  layout: {
    padding: '20px',
    margin: '20px',
    colHeight: '50vh',
    siteHeaderHeight: '90px',
    siteHeaderHeightMobile: '64px',
  },
  pageLayout: {
    sectionHeaderPadding: '100px',
    sectionPadding: '150px',
    sectionPaddingSmall: '10vh',
    sectionPaddingMedium: '10vh',
    sectionPaddingLarge: '14vh',
    sectionPaddingXlarge: '18vh',
  },
});

export default responsiveFontSizes(theme);
